export function UpperFirstChar (input: string): string {
    if (!input) {
        return input
    }
    if (input.length === 1) {
        return input.toUpperCase()
    }
    return input.charAt(0).toUpperCase() + input.slice(1)
}
